import { FC } from 'react';

import '../Modals.scss';
import './EncumbrancesExcelModal.scss';

import EncumbrancesExcelModalHeader from './components/EncumbrancesExcelModalHeader';
import EncumbrancesExcelModalBody from './components/EncumbrancesExcelModalBody';
import EncumbrancesExcelModalFooter from './components/EncumbrancesExcelModalFooter';
import encumbrancesExcelModalSteps from './constants/encumbrancesExcelModalSteps';
import { useEncumbrancesExcelModal } from './context/EncumbrancesExcelModalContext';

const EncumbrancesExcelModal: FC = () => {
  const { data } = useEncumbrancesExcelModal();

  return (
    <>
      <EncumbrancesExcelModalHeader />
      <EncumbrancesExcelModalBody />
      <EncumbrancesExcelModalFooter />

      {data.isLoading && !data.isParsingExcel && data.step !== encumbrancesExcelModalSteps.IMPORTING && (
        <div className="encumbrances-excel-modal__overlay-loading">
          <div
            className="spinner-border text-primary"
            role="status"
            data-testid="encumbrances-excel-overlay-loading"
          />
        </div>
      )}
    </>
  );
};

export default EncumbrancesExcelModal;
